import {ReducerBuilder} from "co-redux-builders";
import {PagerBackendProps} from "../../../../components/Pager";
import DocumentListAdminScreenActions from "./DocumentListcardAdminActions";
import DocumentModel from "../../../../model/Document";
import TaskDocumentList, {DocumentCriteriaProps} from "../../../../ws/document/TaskDocumentList";
import TaskDocumentDelete from "../../../../ws/document/TaskDocumentDelete";

interface InitialState {
    loading: boolean,
    documents: DocumentModel[],
    error: string,
    pager: PagerBackendProps,
    criteria: DocumentCriteriaProps
}

const INITIAL_STATE: InitialState = {
    loading: false,
    documents: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1
    },
    criteria: {}
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskDocumentDelete.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskDocumentDelete.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })

    .onEvent(TaskDocumentList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskDocumentList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskDocumentList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskDocumentList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            documents: payload.data,
            pager: payload.pager || oldState.pager,
        }
    })
    .onEvent(DocumentListAdminScreenActions.onSetCriteria, (oldState, payload) => {
        return (
            {
                ...oldState,
                criteria: payload.criteria
            }
        )
    })

    .onEvent(DocumentListAdminScreenActions.clearReducer, ((oldState, payload) => INITIAL_STATE))

    .build()